import { connect } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';

import { getPageComponent } from './selectors/pageComponentSelector';

import './lib/auth';

const App = ({ pageComponent }) => pageComponent;

const mapStateToProps = state => ({
  pageComponent: getPageComponent(state),
});

export default connect(mapStateToProps, {})(App);



// WEBPACK FOOTER //
// ./src/App.js